import { Create } from 'react-admin';
import { TargetForm } from './Target.Form';

export const TargetCreate = () => {
    return (
        <Create redirect="list">
            <TargetForm />
        </Create>
    );
};
